import React from 'react';
import { format, parseISO } from 'date-fns';

type GeneratedAtLabelProps = {
    generatedAt?: string;
    /** Lets a caller size it for where it sits — a page footnote reads larger than one in a dialog. */
    className?: string;
};

/**
 * Dates a set of stats. The counts are read live rather than locked, so an operator acting on
 * them — deleting, say — is acting on a snapshot; saying when it was taken is the whole mitigation.
 */
const GeneratedAtLabel = ({ generatedAt, className = 'text-sm text-grey-70' }: GeneratedAtLabelProps) => {
    if (!generatedAt) {
        return null;
    }

    return <span className={className}>Figures as of {format(parseISO(generatedAt), 'd MMM yyyy, HH:mm')}</span>;
};

export default GeneratedAtLabel;
